"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTime = exports.PriceData = exports.Firestore = void 0;

var yup = _interopRequireWildcard(require("yup"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/**
 * This is where custom types live. These are mostly used by the 
 * schemas for validation, but I suppose they can be used anywhere
 * 
 */

/**
 * In order to keep this package agnostic from 
 * the particular firebase implementation (admin vs client),
 * these types use feature detection as opposed to checking 
 * for an instance of a class.
 */
const Firestore = {
  Timestamp: yup.object({
    seconds: yup.number().default(0),
    nanoseconds: yup.number().default(0)
  }),
  DocumentReference: yup.object({
    id: yup.string().required(),
    path: yup.string().required()
  })
  /**
   * Used for items and the like
   */

};
exports.Firestore = Firestore;
const PriceData = yup.object({
  day: yup.number(),
  week: yup.number(),
  month: yup.number(),
  formatted: yup.object({
    day: yup.string(),
    week: yup.string(),
    month: yup.string()
  })
});
exports.PriceData = PriceData;
const DateTime = yup.lazy(val => {
  if (typeof val === 'string' || typeof val === 'number' || val instanceof Date) {
    return yup.date();
  }

  return Firestore.Timestamp;
});
exports.DateTime = DateTime;
//# sourceMappingURL=index.js.map